import React, { useEffect, useState } from "react";
import Tabs from "component/common/Tabs";
import AddButton from "component/common/AddButton/index";
import { Link, useLocation, useHistory } from "react-router-dom";
import SearchInput from "component/common/SearchInput";
import Staff from "./Staff/index";
import Role from "./Role/index";
import { debounce } from "debounce";

import styles from "./StaffAndRoles.module.scss";
import { getRoleAction } from "utils/helper";

const StaffLayout = () => {
  const location = useLocation();

  const history = useHistory();

  const { isOperationAvailable } = getRoleAction("Staffs & Roles");

  const tab = new URLSearchParams(location.search).get("tab");

  const page = new URLSearchParams(location.search).get("page");

  const tabs = [
    { label: "role", to: "/admin/staffs&roles?tab=role" },
    { label: "staff", to: "/admin/staffs&roles?tab=staff" },
  ];

  useEffect(() => {
    document.getElementById("search-input").value = "";
  }, [tab]);

  const isActive = () => {
    if (tab == "role") {
      return 0;
    } else if (tab == "staff") {
      return 1;
    }
  };

  const handleSearch = async (event) => {
    await history.push({ search: `?tab=${tab}&search=${event}` });
  };

  const pages = [<Role />, <Staff />];

  return (
    <>
      <div className="row d-flex align-items-center mb-2">
        <div className="col-md-6">
          <div className={styles.staff_header}>
            <div className={styles.title}>
              <b>Staff &amp; Roles</b>
            </div>
            <Tabs page={tab} tabs={tabs} />
          </div>
        </div>
        <div className="col-md-6">
          <div className={styles.staff_search}>
            <Link to={`/admin/staffs&roles/add-${tab}`}>
              {tab === "role" && isOperationAvailable("Add Role") && (
                <AddButton label="ADD NEW ROLE" />
              )}
              {tab == "staff" && isOperationAvailable("Add Staff") && (
                <AddButton label="ADD STAFF" />
              )}
            </Link>
            <div className={styles.search}>
              <SearchInput
                placeholder="Search"
                onChange={debounce(handleSearch, 500)}
                onSearch={() => console.log("search")}
              />
            </div>
          </div>
        </div>
      </div>
      <div>{pages[isActive()]}</div>
    </>
  );
};

export default StaffLayout;
